import { Button, Modal } from 'antd';
import { useCallback, useEffect, useState } from 'react';

interface AdditionalFilePreviewProps {
  fileName: string;
  fileUrl: string;
  onDelete: (file: string) => void;
  disabled?: boolean;
}

export const AdditionalFilePreview: React.FC<AdditionalFilePreviewProps> = ({ fileName, fileUrl, onDelete, disabled }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const formattedFileName = fileName.split('/').pop() ?? '';
  const formattedFileNameType = formattedFileName.split('.').pop();
  const [isDownloadProcessing, setIsDownloadProcessing] = useState(false);
  const handleDownload = useCallback(() => {
    setIsDownloadProcessing(true);
    fetch(fileUrl)
      .then((response) => (response.ok ? response.blob() : Promise.reject('Network response was not ok')))
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = formattedFileName || 'download.pdf';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        setIsDownloadProcessing(false);
      })
      .catch((error) => {
        console.error('Download failed:', error);
        setIsDownloadProcessing(false);
      });
  }, [fileUrl, formattedFileName]);

  useEffect(
    () => () => {
      URL.revokeObjectURL(fileUrl);
    },
    [fileUrl]
  );

  return (
    <div className="flex items-center space-x-6">
      <Button danger onClick={() => onDelete(formattedFileName)} disabled={disabled}>
        Delete
      </Button>
      <Button type="primary" onClick={handleDownload} loading={isDownloadProcessing}>
        Download
      </Button>
      <Button type="primary" onClick={() => showModal()}>
        View
      </Button>
      <span>{formattedFileName}</span>

      <Modal 
        title={`Preview: ${formattedFileName}`}
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={800}
        {...(formattedFileNameType !== 'pdf' ? {style: {display: 'flex', justifyContent: 'center', alignItems: 'center'}} : {})}
      >
        <embed src={fileUrl} width="100%" height="500px" style={{ border: 'none' }} title={`PDF Preview: ${formattedFileName}`} />
      </Modal>

    </div>
  );
};
